//@flow
import React from 'react';
import Link from '../../../components/Link';
import SessionActions from '../../Actions/session';

type Props = {
  label:string,
  hasSub:boolean,
};

function _getSub2SaveLink(props:Props) {
  if (props.hasSub) {
    return (
      <li role="menuitem" tabIndex="0">
        <Link to="/account/subscription">Subscriptions</Link>
      </li>
    );
  }
}

export default function AccountDropdown(props:Props) {
  return (
    <div tabIndex="0" role="tabpanel" className="nb-dropdown account-dropdown">
      <div className="nb-dropdown-label-container">
        <Link to="/account" className="nb-dropdown-label-link">
          <div className="nb-dropdown-label">
            {props.label}
          </div>
          <div className="nb-dropdown-icon">
          </div>
        </Link>
      </div>
      <ul aria-hidden="false" aria-label="submenu" className="nb-dropdown-items">
        <li role="menuitem">
          <Link to="/account">Account settings</Link>
        </li>
        <li role="menuitem">
          <Link to="/orders">Order history</Link>
        </li>
        {_getSub2SaveLink(props)}
        <li role="menuitem">
          <Link to="/my-products" external={true}>
            My products
          </Link>
        </li>
        <li role="menuitem">
          <Link to="/snackpass-admin" className="nb-dropdown-item-link" external={true}>
            <div className="nb-dropdown-item-left">NEW</div>
            <div className="nb-dropdown-item-right">SnackPass</div>
          </Link>
        </li>
        <li role="menuitem">
          <button onClick={SessionActions.logout}>
            Log out
          </button>
        </li>
      </ul>
    </div>
  );
}
